import { FormattedMessage } from 'react-intl'

const OperatorReply = ({ operatorReply, operatorTitle, operatorImg }) => {
  return (
    <div className='reply'>
      <div className='reply-img-wrap'>
        <img src={operatorImg} />
      </div>
      <div className='reply-text'>
        <span>
          <FormattedMessage
            id='review_reply_answer'
            defaultMessage='Answer from'
          />
          &nbsp;
          {operatorTitle}
        </span>
        <p>{operatorReply}</p>
      </div>
    </div>
  )
}

export default OperatorReply
